import { MilestoneChecklistStatus, MilestoneType } from '../../../../entities/workflow/constants/workflow.constants'

export enum WorkspaceSelectType {
  All = 'All',
  Milestone = MilestoneType.Milestone,
  Activity = MilestoneType.Activity,
}

export enum WorkspaceTableMode {
  Full = 'Full',
  Dates = 'Date',
}

export enum WorkspaceWorkMode {
  Filling = 'Filling',
  Checking = 'Checking',
}

export enum WorkspaceExcelExport {
  Current = 'Current',
  FullDates = 'FullDates',
  Full = 'Full',
}

export const workspaceExcelExportOptions = [
  {
    key: WorkspaceExcelExport.Current,
    label: 'export.current',
  },
  // {
  //   key: WorkspaceExcelExport.FullDates,
  //   label: 'export.fullDates',
  // },
  // {
  //   key: WorkspaceExcelExport.Full,
  //   label: 'export.full',
  // },
]

export const startFillChecklistStatuses = [
  MilestoneChecklistStatus.New,
  MilestoneChecklistStatus.Completed,
  MilestoneChecklistStatus.CheckFailed,
  MilestoneChecklistStatus.ReadyToCheck,
]

export const disableFillStatuses = [MilestoneChecklistStatus.Checking]

export const unblockedFormStatuses = [MilestoneChecklistStatus.InProgress]
